import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { verifyCertificateToken } from './certificateActions';
import { useToast } from '../../Utils/toastContext';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useInRouterContext } from 'react-router-dom';
import { clearCustomerName, setClientId } from '../../Redux/store/userSlice';

const CertificateAction = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  console.log('Router context:', useInRouterContext());
  const { externalToken } = useParams();

  //  const location = useLocation();
  const dispatch = useDispatch();
  const { certificateData, loading, error } = useSelector(
    (state) => state.certificate,
  );

  const [token, setToken] = useState(null);
  const submitCertificateDecisionAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/certificates/shared/${externalToken}/accept`;
    const bodyData = {};

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  useEffect(() => {
    const t = externalToken;
    if (t) {
      setToken(t);
      dispatch(verifyCertificateToken(t));
      sessionStorage.removeItem('pendingCertificateToken');
    }
  }, [externalToken]);
  useEffect(() => {
    if (error) {
      showToast(error, 'error');
      navigate('/');
    }
  }, [error]);
  const handleDecision = async (action) => {
    try {
      let response = await submitCertificateDecisionAPI();
      if (response.status == 200) {
        showToast(`Now you can view this customer's certificate`, 'success');
        dispatch(clearCustomerName());
        let redirectState = {
          path: `/customer-details/${response.data.customer_user_id}`,
          state: {
            from: '/customer-list',
            historyStack: [
              ...(location.state?.historyStack || []),
              location.pathname,
            ],
          },
        };
        sessionStorage.setItem(
          'redirectAfterLogin',
          JSON.stringify(redirectState),
        );
        navigate(`/customer-details/${response.data.customer_user_id}`, {
          state: {
            from: '/customer-list',
            historyStack: [
              ...(location.state?.historyStack || []),
              location.pathname,
            ],
          },
        });
      }
    } catch (err) {
      //showToast(err.message, "error");
    }
  };

  if (loading) return <div>Verifying...</div>;
  // if (error) return <div>{error}</div>;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      {!error && (
        <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden animate-fadeIn">
          {/* Header */}
          <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-6 py-5">
            <h2 className="text-white text-lg font-semibold">
              Certificate Access Invite
            </h2>
            <p className="text-blue-100 text-sm mt-1">
              Secure acceptance required
            </p>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center">
                <span className="text-indigo-600 text-xl">🔐</span>
              </div>
            </div>

            <p className="text-gray-700 text-base leading-relaxed">
              Access to this certificate requires accepting the invitation.
            </p>

            <p className="text-xs text-gray-400 mt-2">
              This action will be recorded for audit purposes.
            </p>
          </div>

          {/* Actions */}
          <div className="px-6 pb-6 flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => navigate('/')}
              className="w-full sm:w-1/2 px-4 py-2.5 rounded-xl border border-red-200 text-red-600 font-medium hover:bg-red-50 transition"
            >
              Reject
            </button>

            <button
              onClick={() => handleDecision('accept')}
              className="w-full sm:w-1/2 px-4 py-2.5 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 text-white font-medium shadow-md hover:scale-[1.02] transition"
            >
              Accept
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
// const CertificateAction = () => {
//   return <div>Test</div>;
// };
export default CertificateAction;
